import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import Settings from '@/classes/Settings';

const state = {
  incomingNotificationSounds: [],
  selectedIncomingNotificationSound: {
    value: 'off',
    buffer: null
  },
  settings: new Settings(null)
};

export default {
  namespaced: true,
  actions,
  getters,
  mutations,
  state
};
